module.exports = __webpack_public_path__ + "images/img-1scg2H4.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks/3.png
// module id = 1760
// module chunks = 0